import { useEffect, useState } from "react";

// controllers
import { UserController } from "controllers";

// components
import { Hero } from "shared/components/bulma/hero";
import { Boxes } from "shared/components/customers/boxes";

const CustomerBoxes = ({ customerId }) => {
    const [boxes, setBoxes] = useState([]);
    const [customer, setCustomer] = useState({});

    useEffect(() => {
        const getBoxes = async () => {
            const b = await UserController.getUserBoxes(customerId);
            setBoxes(b);
        }

        const getCustomer = async () => {
            const c = await UserController.getUserById(customerId);
            setCustomer(c);
        }

        getBoxes();
        getCustomer();
    }, [customerId]);

    if (!customer?.id) {
        return null;
    }

    return (
        <Hero className="is-primary">
            <Boxes edit={true} customer={customer} boxes={boxes} />
        </Hero>
    );
}

export { CustomerBoxes };
